(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3205],{

/***/ 80580:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/contracts",
      function () {
        return __webpack_require__(81304);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46687);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2208);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71631);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69274);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);









const CtaOne = (param)=>{
    let { heading1 , heading2 , heading3 , paragraph , paragraphStyling , buttonsStyling , buttonPrimaryText , buttonPrimaryUrl , buttonPrimaryIcon , buttonPrimaryBorderShadow , buttonPrimaryNewTab , buttonPrimaryBg , buttonSecondaryText , buttonSecondaryUrl , buttonSecondaryIcon , buttonSecondaryNewTab , signaturePopupOpen  } = param;
    var _context_globalData, _context_globalData_utmData;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        open: false,
        mode: "register"
    });
    const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const isSignaturePage = signaturePopupOpen;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var _context_globalData, _context_globalData_utmData;
        setIs1DollarTrialCampaignState((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .is1DollarTrialCampaign */ .Og)({
            utm_campaign: context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
        }));
    }, [
        context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-7 sm:gap-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isPopupOpen: signaturePopup.open && isSignaturePage,
                mode: signaturePopup.mode,
                setIsPopupOpen: (value)=>setSignaturePopup((prev)=>({
                            ...prev,
                            open: value
                        })),
                setMode: (mode)=>setSignaturePopup((prev)=>({
                            ...prev,
                            mode: mode
                        }))
            }),
            heading1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl",
                children: heading1
            }),
            heading2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold leading-[45px] sm:leading-[55px] lg:leading-tight text-[36px] sm:text-[48px] lg:text-5xl",
                children: heading2
            }),
            heading3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "font-bold text-2xl sm:text-3xl",
                children: heading3
            }),
            paragraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg sm:text-xl ".concat(paragraphStyling),
                children: paragraph
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 flex items-center flex-wrap gap-4 sm:gap-6 ".concat(buttonsStyling && buttonsStyling),
                children: [
                    buttonPrimaryText && (isSignaturePage ? is1DollarTrialCampaignState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .Button1 */ .g, {
                        btnText: buttonPrimaryText,
                        bgColor: buttonPrimaryBg || "bg-violet-500",
                        textColor: "text-white",
                        border: "border border-violet-500 ",
                        showLoading: false,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {}),
                        borderShadow: buttonPrimaryBorderShadow !== null && buttonPrimaryBorderShadow !== void 0 ? buttonPrimaryBorderShadow : true,
                        px: "px-5"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .ButtonPrimaryDiv */ .gf, {
                        buttonText: buttonPrimaryText,
                        onclick: ()=>setSignaturePopup((prev)=>({
                                    ...prev,
                                    open: true
                                })),
                        buttonUrl: buttonPrimaryUrl,
                        icon: buttonPrimaryIcon,
                        borderShadow: buttonPrimaryBorderShadow,
                        newTab: buttonPrimaryNewTab,
                        bgColor: buttonPrimaryBg
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonPrimary */ .IS, {
                        buttonText: buttonPrimaryText,
                        buttonUrl: buttonPrimaryUrl,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {})
                    })),
                    buttonSecondaryText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonSecondaryBorder */ .AL, {
                        buttonText: buttonSecondaryText,
                        buttonUrl: buttonSecondaryUrl
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CtaOne);


/***/ }),

/***/ 81304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ contracts; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/CLM/v3/Buttons.jsx
var Buttons = __webpack_require__(56475);
;// CONCATENATED MODULE: ./components/v2/Cards/ContractsCard.jsx





const ContractsCard = (param)=>{
    let { image , iconBg , borderColor , title , description , contractsUrl  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: contractsUrl,
        className: "group h-full w-full flex flex-col gap-4 rounded-2xl border border-gray-200 transition-all duration-500 ease-in-out text-center overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex items-center justify-center mx-auto bg-slate-50\n        ",
                children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-[200px] w-full flex justify-center items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image,
                        alt: title,
                        loading: "lazy",
                        width: 100,
                        height: 100,
                        className: "w-auto h-full object-cover mx-auto p-6 "
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex flex-col gap-2 text-left px-6 pb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-xl sm:text-2xl font-bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-lg sm:text-xl text-gray-800",
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full mt-3 flex justify-start ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMLinkPrimaryArrow */.c$, {
                            buttonText: "View Contracts",
                            buttonUrl: contractsUrl
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Cards_ContractsCard = (ContractsCard);

// EXTERNAL MODULE: ./components/v2/CTA/CtaOne.jsx
var CtaOne = __webpack_require__(59183);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/esm/index.js + 42 modules
var esm = __webpack_require__(62194);
;// CONCATENATED MODULE: ./pages/signature/contracts/index.jsx




// import { BsArrowRight, BsBriefcaseFill } from "react-icons/bs";
// import { AiFillHome } from "react-icons/ai";
// import { MdFamilyRestroom } from "react-icons/md";







const addHyphenInUrl = (str)=>{
    return str.replace(/\s+/g, "-").toLowerCase();
};
const contractsCategories = [
    {
        image: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/contracts/family.png",
        iconBg: "bg-red-100/50",
        borderColor: "border-red-500",
        title: "Personal Family",
        description: "Essential agreements for family matters, from wills to custody arrangements.",
        contractsUrl: "/signature/contracts/personal-family"
    },
    {
        image: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/contracts/real-estate.png",
        iconBg: "bg-blue-100/50",
        borderColor: "border-blue-500",
        title: "Real Estate",
        description: "Key contracts for buying, selling, and managing property transactions.",
        contractsUrl: "/signature/contracts/real-estate"
    },
    {
        image: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/contracts/business.png",
        iconBg: "bg-yellow-100/50",
        borderColor: "border-yellow-500",
        title: "Business",
        description: "Comprehensive contracts for startups, partnerships, and corporate dealings.",
        contractsUrl: "/signature/contracts/business"
    }
];
const Contracts = (param)=>{
    let { categories  } = param;
    const [search, setSearch] = (0,react.useState)("");
    const [searchLoading, setSearchLoading] = (0,react.useState)(false);
    const [searchResults, setSearchResults] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const handleSearch = async ()=>{
            // console.log("searching");
            setSearchLoading(true);
            const response = await fetch("".concat(constants.BASE_URL_POST, "search-contracts"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    searchQuery: search
                })
            });
            const data = await response.json();
            const { contracts  } = data;
            setSearchResults(contracts);
            setSearchLoading(false);
        };
        let timer = setTimeout(()=>{
            if (search.length > 0) {
                handleSearch();
            } else {
                setSearchResults([]);
            }
        }, 1000);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        search
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Download Legal Teamplates from BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Download free legal document templates like purchase agreements, NDAs, contracts and more. All templates are professionally drafted by lawyers and can be easily customized."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: " "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/contracts/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Get all the Legal documents and use them as you like, download, modify and send for signing using BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/contracts/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Get all the Legal documents and use them as you like, download, modify and send for signing using BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/contracts/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full mb-20 max-w-screen-xl mx-auto flex flex-col gap-6 sm:gap-12 px-4 md:px-8 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full max-w-screen-xl mx-auto text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaOne/* default */.Z, {
                                heading2: "Find Your Legal Forms"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full max-w-screen-md mx-auto flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-between items-center md:gap-2 w-full h-[50px] sm:h-[60px] p-2 rounded-lg bg-white border-[2px] border-gray-800",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-gray-800 text-3xl pl-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiSearch */.jRj, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                value: search,
                                                onChange: (e)=>setSearch(e.target.value),
                                                placeholder: "Search for a document",
                                                className: "h-full w-full px-3 md:flex-1 text-xl text-gray-800 placeholder-gray-800 outline-none border-none",
                                                name: "",
                                                id: ""
                                            }),
                                            searchLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-gray-400",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ThreeDots */.g4, {
                                                    height: "40",
                                                    width: "50",
                                                    radius: "9",
                                                    color: "#a070f2",
                                                    ariaLabel: "three-dots-loading",
                                                    wrapperStyle: {},
                                                    wrapperClassName: "",
                                                    visible: true
                                                })
                                            })
                                        ]
                                    }),
                                    searchResults.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "border-2 rounded-lg bg-white mx-auto w-full mt-5 max-h-[480px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-corner-white scrollbar-track-transparent drop-shadow-xl ",
                                        children: searchResults.map((contract, index)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)((link_default()), {
                                                href: "/signature/contracts/".concat(addHyphenInUrl(contract === null || contract === void 0 ? void 0 : contract.categories), "/").concat(contract === null || contract === void 0 ? void 0 : contract.slug),
                                                className: "w-full group flex flex-col hover:bg-gray-50",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full text-left md:px-6 md:pt-6 px-4 pt-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                className: "text-gray-700 text-xl font-semibold leading-snug",
                                                                children: contract === null || contract === void 0 ? void 0 : contract.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "font-normal text-base text-gray-700",
                                                                children: contract === null || contract === void 0 ? void 0 : contract.description
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-full flex justify-end items-center pr-4 border-b border-gray-200 pb-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMLinkPrimaryArrow */.c$, {
                                                            buttonText: "Create Document",
                                                            buttonUrl: "/signature/contracts/".concat(addHyphenInUrl(contract === null || contract === void 0 ? void 0 : contract.categories), "/").concat(contract === null || contract === void 0 ? void 0 : contract.slug)
                                                        })
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            searchResults.length > 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaOne/* default */.Z, {
                                paragraph: "Get all the Legal documents and use them as you like, download, modify and send for signing using BoloForms.",
                                paragraphStyling: "max-w-screen-sm mx-auto mt-8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full h-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8",
                        children: contractsCategories.map((contract, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards_ContractsCard, {
                                ...contract
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var contracts = (Contracts);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(80580); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);